import { PERSPECTIVE_IDS } from "./perspectiveIds";

/** Menu workflow keys → AdminMainArea page ids. */
export const ADMIN_WORKFLOW_TO_PAGE = {
  realEstateSourceControls: "real-estate-source-controls",
  weatherSourceControls: "weather-source-controls",
  financeSourceControls: "finance-source-controls",
  realEstateSources: "real-estate-sources",
  ingestionLogs: "ingestion-logs",
  dataHealth: "data-health",
  dataFlowsConnections: "data-flow-connections",
  dataFlowsDatasets: "data-flow-datasets",
  dataOverview: "data-overview",
  dataFlowsList: "data-flows",
  dataRunsList: "data-runs",
  dataFlowsNew: "data-flow-new",
  dataImageMedia: "data-image-media",
  dataImageMediaCasaMapa: "data-image-media-casamapa",
  dataImageMediaActivity: "data-image-media-activity",
  dataImageMediaCustomers: "data-image-media-customers",
  dataImageMediaBilling: "data-image-media-billing",
  dataImageMediaApi: "data-image-media-api",
  propertyImport: "property-import",
  canonicalListings: "canonical-listings",
  locationQuality: "real-estate-location-quality",
  mediaQualityDashboard: "real-estate-media-quality",
  geocodeQueue: "geocode-queue",
  availabilityReview: "real-estate-review",
  duplicateReview: "duplicate-review",
  moderation: "moderation",
  users: "users",
  roles: "roles",
  partners: "partners",
  leadBrokerConfig: "lead-broker-config",
  auditLog: "audit-log",
  platformIam: "platform-iam",
  applicationHealth: "application-health",
  privacyOperations: "privacy-operations",
  foodSourceDiscovery: "food-source-discovery",
  vehicleSources: "real-estate-source-controls",
  vehicleSourceReview: "vehicle-source-review",
  vehicleLookups: "vehicle-lookups",
  vehicleIngestionRuns: "ingestion-logs",
  vehiclePriceEvents: "vehicle-price-events",
  vehicleLifecycleEvents: "vehicle-lifecycle-events",
  vehicleNormalizationIssues: "vehicle-normalization-issues",
  vehicleDuplicateReview: "vehicle-duplicate-review",
  canonicalVehicles: "canonical-vehicles",
  vehicleModelCopy: "vehicle-model-copy",
  vehicleModelCopyQuality: "vehicle-model-copy-quality",
  vehicleSourceHealth: "vehicle-source-health",
  vehicleDataQuality: "vehicle-data-quality",
  vehicleFairValue: "vehicle-fair-value",
  vehicleBestValue: "vehicle-best-value",
  vehicleNewPriceBaselines: "vehicle-new-price-baselines",
  vehicleDepreciation: "vehicle-depreciation",
  vehiclePredictivePricing: "vehicle-predictive-pricing",
  vehiclePricingModels: "vehicle-pricing-models",
  vehicleDealFinder: "vehicle-deal-finder",
  vehicleAlerts: "vehicle-alerts",
  vehicleMarketAnalytics: "vehicle-market-analytics",
  automotiveDealerCoverage: "automotive-dealer-coverage",
  automotiveDealers: "automotive-dealers",
  automotiveDealerReview: "automotive-dealer-review",
  automotiveDealerGovernance: "automotive-dealer-governance",
  foodNormalization: "food-normalization",
  foodBasketCalculation: "food-basket-calculation",
  foodWholesaleIngestion: "food-wholesale-ingestion",
  foodRetailIngestion: "food-retail-ingestion",
  foodAraNormalizationReview: "food-ara-normalization-review",
  foodSupplyIngestion: "food-supply-ingestion",
  foodInputIngestion: "food-input-ingestion",
  foodAccessMap: "food-access-map",
  foodAccessOperations: "food-access-operations",
  foodStoreReviewQueue: "food-store-review-queue",
  foodChainBranchLocatorStrategy: "food-chain-branch-locator-strategy",
  foodChainBranchImports: "food-chain-branch-imports",
  foodChainLocatorAudits: "food-chain-locator-audits",
  foodStoreReconciliation: "food-store-reconciliation",
  foodRecommendations: "food-recommendations",
  transportQa: "transport-qa",
  transportPublicPages: "transport-public-pages",
  transportOperations: "transport-operations",
  transportServiceAlerts: "transport-service-alerts",
  transportLiveOperations: "transport-live-operations",
  transportReports: "transport-reports",
  transportMobilityReports: "transport-mobility-reports",
  transportRoadIncidents: "transport-road-incidents",
  cultureSubmissions: "culture-submissions",
  cultureTaxonomy: "culture-taxonomy",
  cultureModeration: "culture-moderation",
  cultureDashboard: "culture-dashboard",
};

/** Kept in the URL registry so old Data & Ingestion admin links still resolve. */
export const ADMIN_DATA_INGESTION_SECTION = {
  id: "data-ops",
  label: "Data & Ingestion",
  icon: "database",
  items: [
    { id: "data-sources", label: "Data Sources", workflow: "realEstateSourceControls" },
    { id: "data-health", label: "Data Health", workflow: "dataHealth" },
    { id: "ingestion-logs", label: "Ingestion Logs", workflow: "ingestionLogs" },
    { id: "broker-feeds", label: "Broker Feeds", workflow: "realEstateSources" },
    { id: "property-import", label: "CSV Import", workflow: "propertyImport" },
  ],
};

export const ADMIN_REAL_ESTATE_SECTION = {
  id: "real-estate",
  label: "Real Estate",
  icon: "building",
  items: [
    { id: "canonical-listings", label: "Canonical Listings", workflow: "canonicalListings" },
    { id: "geocode-queue", label: "Geocoding Queue", workflow: "geocodeQueue" },
    { id: "availability-review", label: "Availability Review", workflow: "availabilityReview" },
    { id: "duplicate-review", label: "Duplicate Review", workflow: "duplicateReview" },
    { id: "location-quality", label: "Location Quality", workflow: "locationQuality" },
    { id: "media-quality", label: "Media Quality", workflow: "mediaQualityDashboard" },
  ],
};

export const ADMIN_VEHICLE_MARKET_SECTION = {
  id: "vehicle-market",
  label: "Vehicle Market",
  icon: "car",
  items: [
    { id: "vehicle-source-review", label: "Source Review", workflow: "vehicleSourceReview" },
    { id: "vehicle-normalization-issues", label: "Normalization Issues", workflow: "vehicleNormalizationIssues" },
    { id: "vehicle-duplicate-review", label: "Duplicate Review", workflow: "vehicleDuplicateReview" },
    { id: "canonical-vehicles", label: "Canonical Vehicles", workflow: "canonicalVehicles" },
    { id: "vehicle-model-copy", label: "Model Copy", workflow: "vehicleModelCopy" },
    { id: "vehicle-model-copy-quality", label: "Copy Quality", workflow: "vehicleModelCopyQuality" },
    { id: "vehicle-data-quality", label: "Data Quality", workflow: "vehicleDataQuality" },
    { id: "automap-admin", label: "AutoMapa Operations", workflow: "automapAdmin" },
  ],
};

export const ADMIN_WEATHER_SECTION = {
  id: "weather",
  label: "Weather",
  icon: "cloud",
  items: [{ id: "weather-console", label: "Weather Console", workflow: "weatherConsole" }],
};

export const ADMIN_FOOD_SECTION = {
  id: "food-data",
  label: "Food",
  icon: "database",
  items: [
    { id: "food-source-discovery", label: "Supermarket Discovery", workflow: "foodSourceDiscovery" },
    { id: "food-retail-ingestion", label: "Retail Ingestion", workflow: "foodRetailIngestion" },
    { id: "food-wholesale-ingestion", label: "SIPSA Wholesale", workflow: "foodWholesaleIngestion" },
    { id: "food-store-review-queue", label: "Store Quality", workflow: "foodStoreReviewQueue" },
    { id: "food-access-map", label: "Food Access Map", workflow: "foodAccessMap" },
  ],
};

export const ADMIN_TRANSPORT_SECTION = {
  id: "transport-data",
  label: "Transport",
  icon: "database",
  items: [
    { id: "transport-qa", label: "QA Review", workflow: "transportQa" },
    { id: "transport-operations", label: "Operations", workflow: "transportOperations" },
    { id: "transport-service-alerts", label: "Service Alerts", workflow: "transportServiceAlerts" },
    { id: "transport-live-operations", label: "Live Operations", workflow: "transportLiveOperations" },
    { id: "transport-mobility-reports", label: "Mobility Reports", workflow: "transportMobilityReports" },
  ],
};

export const ADMIN_CULTURE_SECTION = {
  id: "content",
  label: "Culture & Community",
  icon: "shield",
  items: [
    { id: "moderation", label: "Community Reports", workflow: "moderation" },
    { id: "culture-dashboard", label: "Culture Coverage", workflow: "cultureDashboard" },
    { id: "culture-submissions", label: "Submissions", workflow: "cultureSubmissions" },
    { id: "culture-moderation", label: "Culture Moderation", workflow: "cultureModeration" },
    { id: "culture-taxonomy", label: "Taxonomy", workflow: "cultureTaxonomy" },
  ],
};

export const ADMIN_PLATFORM_SECTION = {
  id: "platform",
  label: "Platform",
  icon: "users",
  items: [
    { id: "client-views-admin", label: "Client Views", workflow: "clientViewsAdmin" },
    { id: "application-health", label: "Application Health", workflow: "applicationHealth" },
    { id: "platform-iam", label: "IAM", workflow: "platformIam" },
    { id: "users", label: "Users", workflow: "users" },
    { id: "roles-admin", label: "Roles & Permissions", workflow: "roles" },
    { id: "partners", label: "Broker Partners", workflow: "partners" },
    { id: "lead-broker-config", label: "Lead Broker", workflow: "leadBrokerConfig" },
    { id: "privacy-operations", label: "Privacy Operations", workflow: "privacyOperations" },
    { id: "audit-log", label: "Audit Log", workflow: "auditLog" },
  ],
};

export const ADMIN_DISPLAY_SECTIONS_BY_PERSPECTIVE = {
  [PERSPECTIVE_IDS.ADMINISTRATION]: [ADMIN_PLATFORM_SECTION],
  [PERSPECTIVE_IDS.REAL_ESTATE]: [ADMIN_REAL_ESTATE_SECTION],
  [PERSPECTIVE_IDS.TRANSPORT]: [ADMIN_VEHICLE_MARKET_SECTION, ADMIN_TRANSPORT_SECTION],
  [PERSPECTIVE_IDS.AUTOMOTIVE]: [ADMIN_VEHICLE_MARKET_SECTION, ADMIN_TRANSPORT_SECTION],
  [PERSPECTIVE_IDS.WEATHER]: [ADMIN_WEATHER_SECTION],
  [PERSPECTIVE_IDS.FOOD]: [ADMIN_FOOD_SECTION],
  [PERSPECTIVE_IDS.CULTURE]: [ADMIN_CULTURE_SECTION],
};

/** Every section that can appear in an `admin=` URL, including retired Admin copies. */
export const ALL_ADMIN_MENU_SECTIONS = [
  ADMIN_DATA_INGESTION_SECTION,
  ADMIN_REAL_ESTATE_SECTION,
  ADMIN_VEHICLE_MARKET_SECTION,
  ADMIN_WEATHER_SECTION,
  ADMIN_FOOD_SECTION,
  ADMIN_TRANSPORT_SECTION,
  ADMIN_CULTURE_SECTION,
  ADMIN_PLATFORM_SECTION,
];

const ADMIN_PAGE_OWNER = (() => {
  const owners = {};
  const assign = (section, perspectiveId) => {
    for (const item of section.items || []) {
      owners[item.id] = perspectiveId;
      const pageId = ADMIN_WORKFLOW_TO_PAGE[item.workflow];
      if (pageId) {
        owners[pageId] = perspectiveId;
      }
    }
  };

  assign(ADMIN_REAL_ESTATE_SECTION, PERSPECTIVE_IDS.REAL_ESTATE);
  assign(ADMIN_VEHICLE_MARKET_SECTION, PERSPECTIVE_IDS.TRANSPORT);
  assign(ADMIN_WEATHER_SECTION, PERSPECTIVE_IDS.WEATHER);
  assign(ADMIN_FOOD_SECTION, PERSPECTIVE_IDS.FOOD);
  assign(ADMIN_TRANSPORT_SECTION, PERSPECTIVE_IDS.TRANSPORT);
  assign(ADMIN_CULTURE_SECTION, PERSPECTIVE_IDS.CULTURE);
  assign(ADMIN_PLATFORM_SECTION, PERSPECTIVE_IDS.ADMINISTRATION);
  return owners;
})();

export function getAdminMenuSectionsForPerspective(perspectiveId) {
  return ADMIN_DISPLAY_SECTIONS_BY_PERSPECTIVE[perspectiveId] || [];
}

export function getAdminPageOwnerPerspective(pageId) {
  if (!pageId) {
    return PERSPECTIVE_IDS.ADMINISTRATION;
  }
  return ADMIN_PAGE_OWNER[pageId] || PERSPECTIVE_IDS.ADMINISTRATION;
}

export function perspectiveHostsAdminPages(perspectiveId) {
  return Boolean(ADMIN_DISPLAY_SECTIONS_BY_PERSPECTIVE[perspectiveId]);
}

export function collectSectionWorkflows(sections = []) {
  return sections.flatMap((section) =>
    (section.items || []).map((item) => item.workflow).filter(Boolean)
  );
}
